import React, { Fragment } from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import useValidation from "../../../util/useValidation";
import {
  aadharNumberPattern,
  alphaNumericWithSpecialCharacterPattern,
  alphabetWithSpacePattern,
  BLOOD_GROUPS,
  emailIDPattern,
  mobileNumberPattern,
  panNumberPattern,
  pincodePattern,
  bioPattern,
  ROLES
} from "../../../constants/constants";
import { getFormattedDate } from "../../../util/helpers";
import {
  getAddressId,
  getAddressValue
} from "../../../util/onBoardingDataFilters";
import {
  MARTIAL_TYPES,
  ADDRESS_TYPES,
  NATIONALITY,
  TITLES
} from "../../../constants/constants";

const PersonalDetailsForm = ({
  addressDetails,
  genders,
  loggedInUserId,
  states,
  maritalStatusList,
  personalDetails,
  updatePersonalDetails
}) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnChangePersonalDetails = ({ target: { name, value } }) => {
    updatePersonalDetails(name, value);
  };
  const handleOnChangeAddressDetails = ({ target: { name, value } }, id) => {
    updatePersonalDetails(name.replace("current", ""), value, "addresses", id);
    //append current for validations only, so removing while updating
  };
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  return (
    <Fragment>
      <Card>
        <Card.Header>Personal Details</Card.Header>
        <Card.Body>
          <Form.Group as={Row} controlId="titleDateOfJoining">
            <Col sm={4}>
              <Form.Label>Title (Mr/Ms)*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="title"
                placeholder="Title"
                value={personalDetails.title}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.title}
              >
                <option value="">Choose..</option>
                {TITLES.map(title => (
                  <option value={title.id}>{title.description}</option>
                ))}
              </Form.Control>
              {errors.title && (
                <Form.Control.Feedback type="invalid">
                  {errors.title.type === "required" && "Title is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Date of Joining*</Form.Label>
              <Form.Control
                size="sm"
                required
                disabled
                type="date"
                name="dateofJoining"
                placeholder="Date of Joining"
                value={getFormattedDate(
                  personalDetails.dateofJoining,
                  undefined,
                  "YYYY-MM-DD"
                )}
              />
            </Col>
            <Col sm={4}>
              {loggedInUserId !== ROLES.CANDIDATE && (
                <>
                  <Form.Label>Employee Id</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    name="cDKEmployeeId"
                    placeholder="Employee Id"
                    value={personalDetails.cDKEmployeeId}
                    onChange={handleOnChangePersonalDetails}
                    onBlur={handleOnBlurInput}
                    isInvalid={errors.cDKEmployeeId}
                  />
                </>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="firstNameMiddleNameLastName">
            <Col sm={4}>
              <Form.Label>First Name*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="firstName"
                placeholder="First Name"
                value={personalDetails.firstName}
                onChange={handleOnChangePersonalDetails}
                pattern={alphabetWithSpacePattern}
                onBlur={handleOnBlurInput}
                isInvalid={errors.firstName}
              />
              {errors.firstName && (
                <Form.Control.Feedback type="invalid">
                  {errors.firstName.type === "required" &&
                    "First Name is required"}
                  {errors.firstName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Middle Name</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                name="middleName"
                placeholder="Middle Name"
                value={personalDetails.middleName}
                pattern={alphabetWithSpacePattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.middleName}
              />
              {errors.middleName && (
                <Form.Control.Feedback type="invalid">
                  {errors.middleName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Last Name*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={personalDetails.lastName}
                pattern={alphabetWithSpacePattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.lastName}
              />
              {errors.lastName && (
                <Form.Control.Feedback type="invalid">
                  {errors.lastName.type === "required" &&
                    "Last Name is required"}
                  {errors.lastName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="dobGenderBusinessTitle">
            <Col sm={4}>
              <Form.Label>DOB*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="date"
                name="birthDate"
                value={getFormattedDate(
                  personalDetails.birthDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.birthDate}
              />
              {errors.birthDate && (
                <Form.Control.Feedback type="invalid">
                  {errors.birthDate.type === "required" && "DOB is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Gender*</Form.Label>
              <Form.Control
                size="sm"
                as="select"
                name="gender"
                required
                value={personalDetails.gender}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.gender}
              >
                <option value="">Choose...</option>
                {genders.length &&
                  genders.map(gender => (
                    <option value={gender.id}>{gender.genderType}</option>
                  ))}
              </Form.Control>
              {errors.gender && (
                <Form.Control.Feedback type="invalid">
                  {errors.gender.type === "required" && "Gender is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Business Title*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="cDKDesignation"
                placeholder="Business Title"
                value={personalDetails.cDKDesignation}
                onChange={handleOnChangePersonalDetails}
                pattern={alphaNumericWithSpecialCharacterPattern}
                onBlur={handleOnBlurInput}
                isInvalid={errors.cDKDesignation}
              />
              {errors.cDKDesignation && (
                <Form.Control.Feedback type="invalid">
                  {errors.cDKDesignation.type === "required" &&
                    "Business Title is required"}
                  {errors.cDKDesignation.type === "pattern" &&
                    "Invalid characters entered for Business Title"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="maritalStatusSpouseNameMarriageDate">
            <Col sm={4}>
              <Form.Label>Marital Status*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="maritalStatus"
                placeholder="Marital Status"
                value={personalDetails.maritalStatus}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.maritalStatus}
              >
                <option value="">Choose...</option>
                {maritalStatusList.length &&
                  maritalStatusList.map(maritalStatus => (
                    <option value={maritalStatus.id}>
                      {maritalStatus.marital}
                    </option>
                  ))}
              </Form.Control>
              {errors.maritalStatus && (
                <Form.Control.Feedback type="invalid">
                  {errors.maritalStatus.type === "required" &&
                    "Marital Status is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Spouse Name*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="spouseName"
                placeholder="Spouse Name"
                value={personalDetails.spouseName}
                onChange={handleOnChangePersonalDetails}
                disabled={
                  +personalDetails.maritalStatus === MARTIAL_TYPES.SINGLE
                }
                pattern={alphabetWithSpacePattern}
                onBlur={handleOnBlurInput}
                isInvalid={
                  +personalDetails.maritalStatus !== MARTIAL_TYPES.SINGLE &&
                  errors.spouseName
                }
              />
              {+personalDetails.maritalStatus !== MARTIAL_TYPES.SINGLE &&
                errors.spouseName && (
                  <Form.Control.Feedback type="invalid">
                    {errors.spouseName.type === "required" &&
                      "Spouse Name is required"}
                    {errors.spouseName.type === "pattern" &&
                      "Must contain only alphabets and space"}
                  </Form.Control.Feedback>
                )}
            </Col>
            <Col sm={4}>
              <Form.Label>Marriage Date*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="date"
                name="anniversaryDate"
                onChange={handleOnChangePersonalDetails}
                placeholder="Marriage Date"
                value={getFormattedDate(
                  personalDetails.anniversaryDate,
                  undefined,
                  "YYYY-MM-DD"
                )}
                disabled={
                  +personalDetails.maritalStatus === MARTIAL_TYPES.SINGLE
                }
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="panCardAadharNoPersonalEmailId">
            <Col sm={4}>
              <Form.Label>PAN card*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="panCardNo"
                placeholder="PAN card"
                value={personalDetails.panCardNo}
                pattern={panNumberPattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.panCardNo}
              />
              {errors.panCardNo && (
                <Form.Control.Feedback type="invalid">
                  {errors.panCardNo.type === "required" &&
                    "PAN Number is required"}
                  {errors.panCardNo.type === "pattern" &&
                    "Please enter a valid PAN Number"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Aadhar No*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="adhaarNumber"
                placeholder="Aadhar No"
                value={personalDetails.adhaarNumber}
                pattern={aadharNumberPattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.adhaarNumber}
              />
              {errors.adhaarNumber && (
                <Form.Control.Feedback type="invalid">
                  {errors.adhaarNumber.type === "required" &&
                    "Aadhar Number is required"}
                  {errors.adhaarNumber.type === "pattern" &&
                    "Please enter a valid Aadhar Number"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Personal Email ID*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="emailId"
                placeholder="Personal Email ID"
                value={personalDetails.emailId}
                pattern={emailIDPattern}
                disabled
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.emailId}
              />
              {errors.emailId && (
                <Form.Control.Feedback type="invalid">
                  {errors.emailId.type === "required" && "Email is required"}
                  {errors.emailId.type === "pattern" &&
                    "Please enter a valid Email ID"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="nationalityBloodGroupLanguageKnown">
            <Col sm={4}>
              <Form.Label>Nationality*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="nationality"
                placeholder="Nationality"
                value={personalDetails.nationality}
                onChange={handleOnChangePersonalDetails}
              >
                {NATIONALITY.map(nationality => (
                  <option value={nationality.id}>
                    {nationality.description}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col sm={4}>
              <Form.Label>Blood Group*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="bloodGroup"
                placeholder="Blood Group"
                value={personalDetails.bloodGroup}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.bloodGroup}
              >
                <option value="">Choose...</option>
                {BLOOD_GROUPS.map(bloodGroup => (
                  <option value={bloodGroup.id}>
                    {bloodGroup.description}
                  </option>
                ))}
              </Form.Control>
              {errors.bloodGroup && (
                <Form.Control.Feedback type="invalid">
                  {errors.bloodGroup.type === "required" &&
                    "Blood Group is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={4}>
              <Form.Label>Languages Known*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="languagesKnown"
                placeholder="Languages Known"
                value={personalDetails.languagesKnown}
                onChange={handleOnChangePersonalDetails}
                pattern={alphaNumericWithSpecialCharacterPattern}
                onBlur={handleOnBlurInput}
                isInvalid={errors.languagesKnown}
              />
              {errors.languagesKnown && (
                <Form.Control.Feedback type="invalid">
                  {errors.languagesKnown.type === "required" &&
                    "Languages Know is required"}
                  {errors.languagesKnown.type === "pattern" &&
                    "Invalid characters entered for Languages Know"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="bio">
            <Col sm={12}>
              <Form.Label>Bio*</Form.Label>
              <Form.Control
                  size="sm"
                  required
                  rows={4}
                  as="textarea"
                  name="postHeldNumber"
                  placeholder="I’m an adventurer at heart who loves exploring new places, whether it’s hiking in nature or discovering new cultures through travel. A foodie who enjoys experimenting in the kitchen, I’m always seeking fresh experiences, good conversations, and meaningful connections with people..."
                  value={personalDetails.postHeldNumber}
                  onChange={handleOnChangePersonalDetails}
                  pattern={bioPattern}
                  onBlur={handleOnBlurInput}
                  isInvalid={errors.postHeldNumber}
                  />
                {errors.postHeldNumber && (
                <Form.Control.Feedback type="invalid">
                  {errors.postHeldNumber.type === "required" &&
                    "Bio is required"}
                  {errors.postHeldNumber.type === "pattern" &&
                    "Bio cannot exceed 400 characters."}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Header>Home Address (Permanent Address)</Card.Header>
        <Card.Body>
          <Form.Group as={Row} controlId="AddressLine1">
            <Form.Label column sm={2}>
              Address Line 1*
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="addressLine1"
                placeholder="Address Line 1"
                value={getAddressValue(
                  "addressLine1",
                  addressDetails,
                  ADDRESS_TYPES.PERMANENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.PERMANENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.addressLine1}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.addressLine1 && (
                <Form.Control.Feedback type="invalid">
                  {errors.addressLine1.type === "required" &&
                    "Address Line 1 is required"}
                  {errors.addressLine1.type === "pattern" &&
                    "Invalid characters entered for Address Line 1"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={2} />
          </Form.Group>
          <Form.Group as={Row} controlId="addressLine2">
            <Form.Label column sm={2}>
              Address Line 2*
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="addressLine2"
                placeholder="Address Line 2"
                value={getAddressValue(
                  "addressLine2",
                  addressDetails,
                  ADDRESS_TYPES.PERMANENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.PERMANENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.addressLine2}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.addressLine2 && (
                <Form.Control.Feedback type="invalid">
                  {errors.addressLine2.type === "required" &&
                    "Address Line 2 is required"}
                  {errors.addressLine2.type === "pattern" &&
                    "Invalid characters entered for Address Line 2"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={2} />
          </Form.Group>
          <Form.Group as={Row} controlId="AddressLine3">
            <Form.Label column sm={2}>
              Address Line 3*
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="locality"
                placeholder="Address Line 3"
                value={getAddressValue(
                  "locality",
                  addressDetails,
                  ADDRESS_TYPES.PERMANENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.PERMANENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.locality}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.locality && (
                <Form.Control.Feedback type="invalid">
                  {errors.locality.type === "required" &&
                    "Address Line 3 is required"}
                  {errors.locality.type === "pattern" &&
                    "Invalid characters entered for Address Line 3"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={2} />
          </Form.Group>
          <Form.Group as={Row} controlId="cityStateCountryPostalCode">
            <Col sm={3}>
              <Form.Label>Town/City*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="city"
                placeholder="Town/City"
                value={getAddressValue(
                  "city",
                  addressDetails,
                  ADDRESS_TYPES.PERMANENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.PERMANENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.city}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.city && (
                <Form.Control.Feedback type="invalid">
                  {errors.city.type === "required" && "City is required"}
                  {errors.city.type === "pattern" &&
                    "Invalid characters entered for Town/City"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3}>
              <Form.Label>State*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="state"
                placeholder="State"
                value={getAddressValue(
                  "state",
                  addressDetails,
                  ADDRESS_TYPES.PERMANENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.PERMANENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.state}
              >
                <option value="">Choose...</option>
                {states.map(state => (
                  <option value={state.id}>{state.stateName}</option>
                ))}
              </Form.Control>
              {errors.state && (
                <Form.Control.Feedback type="invalid">
                  {errors.state.type === "required" && "State is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3}>
              <Form.Label>Postal Code*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="pincode"
                placeholder="Postal Code"
                value={getAddressValue(
                  "pincode",
                  addressDetails,
                  ADDRESS_TYPES.PERMANENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.PERMANENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.pincode}
                pattern={pincodePattern}
              />

              {errors.pincode && (
                <Form.Control.Feedback type="invalid">
                  {errors.pincode.type === "required" && "PinCode is required"}
                  {errors.pincode.type === "pattern" &&
                    "Please enter valid PinCode"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3} />
          </Form.Group>
          <Form.Group as={Row} controlId="homePhoneMobilePhone">
            <Col sm={3}>
              <Form.Label>Mobile Phone*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                name="contactNumber"
                placeholder="Mobile Phone"
                value={personalDetails.contactNumber}
                onChange={handleOnChangePersonalDetails}
                pattern={mobileNumberPattern}
                onBlur={handleOnBlurInput}
                isInvalid={errors.contactNumber}
              />
              {errors.contactNumber && (
                <Form.Control.Feedback type="invalid">
                  {errors.contactNumber.type === "required" &&
                    "Mobile Number is required"}
                  {errors.contactNumber.type === "pattern" &&
                    "Please enter a valid Mobile Number"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3}>
              <Form.Label>Home Phone*</Form.Label>
              <Form.Control
                size="sm"
                required
                type="text"
                placeholder="Home Phone"
                name="alternateContactNo"
                value={personalDetails.alternateContactNo}
                pattern={mobileNumberPattern}
                onChange={handleOnChangePersonalDetails}
                onBlur={handleOnBlurInput}
                isInvalid={errors.alternateContactNo}
              />
              {errors.alternateContactNo && (
                <Form.Control.Feedback type="invalid">
                  {errors.alternateContactNo.type === "required" &&
                    "Home Phone Number is required"}
                  {errors.alternateContactNo.type === "pattern" &&
                    "Please enter a valid Home Phone"}
                </Form.Control.Feedback>
              )}
            </Col>

            <Col sm={6} />
          </Form.Group>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>Mailing Address (Current Address)</Card.Header>
        <Card.Body>
          <Form.Group as={Row} controlId="AddressLine1">
            <Form.Label column sm={2}>
              Address Line 1*
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="addressLine1current"
                placeholder="Address Line 1"
                value={getAddressValue(
                  "addressLine1",
                  addressDetails,
                  ADDRESS_TYPES.CURRENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.CURRENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.addressLine1current}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.addressLine1current && (
                <Form.Control.Feedback type="invalid">
                  {errors.addressLine1current.type === "required" &&
                    "Address Line 1 is required"}
                  {errors.addressLine1current.type === "pattern" &&
                    "Invalid characters entered for Address Line 1"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={2} />
          </Form.Group>
          <Form.Group as={Row} controlId="addressLine2">
            <Form.Label column sm={2}>
              Address Line 2*
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                size="sm"
                required
                name="addressLine2current"
                type="text"
                placeholder="Address Line 2"
                value={getAddressValue(
                  "addressLine2",
                  addressDetails,
                  ADDRESS_TYPES.CURRENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.CURRENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.addressLine2current}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.addressLine2current && (
                <Form.Control.Feedback type="invalid">
                  {errors.addressLine2current.type === "required" &&
                    "Address Line2 is required"}
                  {errors.addressLine2current.type === "pattern" &&
                    "Invalid characters entered for Address Line2"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={2} />
          </Form.Group>
          <Form.Group as={Row} controlId="AddressLine3">
            <Form.Label column sm={2}>
              Address Line 3*
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                size="sm"
                required
                name="localitycurrent"
                type="text"
                placeholder="Address Line 3"
                value={getAddressValue(
                  "locality",
                  addressDetails,
                  ADDRESS_TYPES.CURRENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.CURRENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.localitycurrent}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.localitycurrent && (
                <Form.Control.Feedback type="invalid">
                  {errors.localitycurrent.type === "required" &&
                    "Address Line 3 is required"}
                  {errors.localitycurrent.type === "pattern" &&
                    "Invalid characters entered for Address Line 3"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={2} />
          </Form.Group>
          <Form.Group as={Row} controlId="cityStateCountryPostalCode">
            <Col sm={3}>
              <Form.Label>Town/City*</Form.Label>
              <Form.Control
                size="sm"
                required
                name="citycurrent"
                type="text"
                placeholder="Town/City"
                value={getAddressValue(
                  "city",
                  addressDetails,
                  ADDRESS_TYPES.CURRENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.CURRENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.citycurrent}
                pattern={alphaNumericWithSpecialCharacterPattern}
              />

              {errors.citycurrent && (
                <Form.Control.Feedback type="invalid">
                  {errors.citycurrent.type === "required" && "City is required"}
                  {errors.citycurrent.type === "pattern" &&
                    "Invalid characters entered for Town/City"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3}>
              <Form.Label>State*</Form.Label>
              <Form.Control
                size="sm"
                required
                as="select"
                name="statecurrent"
                placeholder="State"
                value={getAddressValue(
                  "state",
                  addressDetails,
                  ADDRESS_TYPES.CURRENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.CURRENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.statecurrent}
              >
                <option value="">Choose...</option>
                {states.map(state => (
                  <option value={state.id}>{state.stateName}</option>
                ))}
              </Form.Control>
              {errors.statecurrent && (
                <Form.Control.Feedback type="invalid">
                  {errors.statecurrent.type === "required" &&
                    "State is required"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3}>
              <Form.Label>Postal Code*</Form.Label>
              <Form.Control
                size="sm"
                name="pincodecurrent"
                required
                type="text"
                placeholder="Postal Code"
                value={getAddressValue(
                  "pincode",
                  addressDetails,
                  ADDRESS_TYPES.CURRENT
                )}
                onChange={e => {
                  handleOnChangeAddressDetails(
                    e,
                    getAddressId(addressDetails, ADDRESS_TYPES.CURRENT)
                  );
                }}
                onBlur={handleOnBlurInput}
                isInvalid={errors.pincodecurrent}
                pattern={pincodePattern}
              />

              {errors.pincodecurrent && (
                <Form.Control.Feedback type="invalid">
                  {errors.pincodecurrent.type === "required" &&
                    "PinCode is required"}
                  {errors.pincodecurrent.type === "pattern" &&
                    "Please enter valid PinCode"}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col sm={3} />
          </Form.Group>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default PersonalDetailsForm;
